import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import useAuth from "@/hooks/useAuth";
import { getFirstErrorMessage } from "@/lib/utils";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormInputField from "@/components/lib/from-input-field";
import { Card, CardContent } from "@/components/ui/card";
import { clearQrCodeMessages, fetchAllQrCode } from "@/redux/slice/order-ordering-slice/qr-codes-slice";
import { createQrCode } from "@/api/online-ordering/settings/qrCode";

function CreateQrCode({ isOpen, onClose }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { user } = useAuth();

  const form = useForm({
    resolver: zodResolver(CreateQrCodeSchema),
    mode: "onChange",
    defaultValues: {
      name: "",
      status: true,
    },
  });
  const errorMessage = getFirstErrorMessage(form);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const isValid = await form.trigger();
    if (!isValid) return;

    const data = form.getValues();
    const payload = {
      ...data,
      client_id: user.client_id,
      restaurant_id: user.restaurant_id,
    };

    try {
      let res;
      res = await createQrCode(payload);

      if (res.status === "success") {
        toast.success("QR code added successfully!");

        form.reset();
        dispatch(fetchAllQrCode(user?.restaurant_id))
        dispatch(clearQrCodeMessages());
        onClose();
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    } catch (err) {
      toast.error(err?.message || "Failed to process Time");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogTitle>
          Add New QR Code
        </DialogTitle>
        {errorMessage && (
          <div className="text-cred mb-2 text-sm flex justify-center items-center text-center">
            {errorMessage}
          </div>
        )}
        <Form {...form}>
          <form>
            <Card className="max-w-screen-md bg-cblack6 mx-auto mt-5 text-cwhite">
              <CardContent>
                <div className="pt-5">
                  <FormInputField
                    name="name"
                    style="bg-cblack7"
                    placeholder={"Enter name"}
                    form={form}
                    type="text"
                    label={"QR Code Name"}
                  />
                </div>
              </CardContent>
            </Card>
            <Button
              isLoading={loading}
              type="submit"
              onClick={(e) =>
                handleSubmit(e)
              }
              disabled={loading}
              className="w-full bg-cgreen text-cwhite mt-5 font-bold"
            >
              Save
            </Button>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}

export default CreateQrCode;

export const CreateQrCodeSchema = z.object({
  name: z.string().min(1, "Name is required")
});
